
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M14.5 14.5v-.69c0-.878-.316-1.72-.879-2.34-.562-.621-1.325-.97-2.121-.97h-6c-.796 0-1.559.349-2.121.97a3.5 3.5 0 0 0-.879 2.34v.69"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"M8.5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6"}})])])
          )
        }
      }
    